import SEO from "../components/common/SEO";
import PageHero from "../components/common/PageHero";
import { Reveal } from "../components/common/Reveal";
import ContactForm from "../components/forms/ContactForm";
import PillButton from "../components/common/PillButton";
import { Phone, Mail, MapPin } from "lucide-react";
import { company } from "../data/site";
import { useStaffing } from "../components/forms/StaffingProvider";

export default function Contact() {
  const { open } = useStaffing();
  return (
    <>
      <SEO
        title="Contact"
        description="Talk to an AMVI Technologies expert about your technology, staffing or transformation requirements."
        path="/contact"
      />
      <PageHero
        eyebrow="Contact"
        title="Let's Build What's Next"
        subtitle="Tell us about your technology, staffing or transformation requirements."
      />

      <section className="px-6 pb-24 pt-8">
        <div className="mx-auto grid max-w-7xl gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <div className="space-y-4">
              <a href={company.phoneHref} className="group flex items-start gap-4 rounded-2xl border border-white/10 bg-ink-800/40 p-6 transition-colors hover:border-sky-400/40" data-testid="contact-info-phone">
                <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-sky-400"><Phone className="h-5 w-5" /></span>
                <div>
                  <div className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">Phone</div>
                  <div className="mt-1 font-heading text-lg font-semibold text-white">{company.phone}</div>
                </div>
              </a>
              <a href={`mailto:${company.email}`} className="group flex items-start gap-4 rounded-2xl border border-white/10 bg-ink-800/40 p-6 transition-colors hover:border-sky-400/40" data-testid="contact-info-email">
                <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-sky-400"><Mail className="h-5 w-5" /></span>
                <div>
                  <div className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">Email</div>
                  <div className="mt-1 font-heading text-lg font-semibold text-white">{company.email}</div>
                </div>
              </a>
              <div className="flex items-start gap-4 rounded-2xl border border-white/10 bg-ink-800/40 p-6" data-testid="contact-info-address">
                <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-sky-400"><MapPin className="h-5 w-5" /></span>
                <div>
                  <div className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">Address</div>
                  <div className="mt-1 text-base leading-relaxed text-slate-300">
                    {company.address.line1}<br />
                    {company.address.city}, {company.address.state} {company.address.zip}<br />
                    {company.address.country}
                  </div>
                </div>
              </div>

              <div className="rounded-2xl border border-white/10 bg-gradient-to-br from-ink-800/80 to-ink-800/30 p-6">
                <h3 className="font-heading text-lg font-bold tracking-tight text-white">Hiring talent?</h3>
                <p className="mt-2 text-sm text-slate-400">Skip the form and submit a staffing requirement directly.</p>
                <div className="mt-4">
                  <PillButton onClick={open} variant="outline" testId="contact-staffing-cta">Submit a Staffing Requirement</PillButton>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-7">
            <div className="rounded-2xl border border-white/10 bg-ink-800/50 p-8 lg:p-10">
              <h2 className="font-heading text-2xl font-bold tracking-tight text-white">Send us a message</h2>
              <p className="mt-2 text-sm text-slate-400">We typically respond within one business day.</p>
              <div className="mt-8">
                <ContactForm />
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
